import MultiSelectInput from '@repo/ui/multiselect-input'
import React from 'react'

import { CurrencyEnum, currencyEnumOptions } from '../../lib/types/enums/common/currency.enum'
import { OLTypeEnum, olTypeEnumMapping } from '../../lib/types/enums/ol/ol-type.enum'
import { LecBankAccountFilters } from '../../lib/types/models/lec-bank-account/lec-bank-account'

type Props = {
  filter?: LecBankAccountFilters
  onFilterChange: (filter: LecBankAccountFilters) => void
}

const LecBankAccountFilter: React.FC<Props> = ({ filter, onFilterChange }) => {
  return (
    <div className="flex flex-col gap-4 pt-2">
      <MultiSelectInput<CurrencyEnum>
        label="Devises"
        variant="primary"
        options={currencyEnumOptions}
        selectedOptions={filter?.currencies?.map((c) => ({
          label: currencyEnumOptions.find((opt) => opt.value === c)?.label || '',
          value: c
        }))}
        onChange={(currencies) => onFilterChange({ ...filter, currencies })}
      />

      <MultiSelectInput<OLTypeEnum>
        label="Types de prestataires"
        variant="primary"
        options={[OLTypeEnum.LEC, OLTypeEnum.PARTNER, OLTypeEnum.RESIDENCE].map((t) => ({
          value: t,
          label: olTypeEnumMapping[t].label
        }))}
        selectedOptions={filter?.olTypes?.map((t) => ({
          label: olTypeEnumMapping[t].label,
          value: t
        }))}
        onChange={(olTypes) => onFilterChange({ ...filter, olTypes })}
      />
    </div>
  )
}

export default LecBankAccountFilter
